import { useEffect } from 'react';

import { useErrorDisplayedCallback } from '@zenbusiness/application-commons-clickstream';
import { useIntl } from '@zenbusiness/application-commons-intl';

function getErrorCodeMessageId(errorCode) {
  return errorCode
    ? `shopping.checkout.error.${errorCode}`
    : 'shopping.page.checkout.error.generic';
}

/**
 * Custom hook to handle payment error and tracking
 *
 * @param {object} params
 * @param {object} params.error - The error object (with errorCode and other details)
 * @returns {object} - Error props and helpers
 */
export function useTrackPaymentError({ error }) {
  const { formatMessage } = useIntl();

  const { errorCode, isFatal: hasFatalError } = error || {};
  const errorMessage = errorCode ? formatMessage({ id: getErrorCodeMessageId(errorCode) }) : null;

  const trackErrorDisplayed = useErrorDisplayedCallback({
    elementName: 'place_order_error',
    elementText: errorMessage,
    elementValue: errorCode
  });

  useEffect(() => {
    if (errorCode) {
      trackErrorDisplayed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCode]);

  return {
    errorCode,
    errorMessage,
    hasFatalError
  };
}

export default useTrackPaymentError;
